import React from 'react';
import { Row, Col, Card, List, Typography, Divider } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function UploadResults({ successList = [], errorList = [], title, successTitle, errorTitle }) {
    if (successList.length === 0 && errorList.length === 0) {
        return null;
    }

    return (
        <div style={{ marginTop: 24, textAlign: 'left' }}>
            {title && <Divider orientation="left">{title}</Divider>}
            <Row gutter={24}>
                <Col span={12}>
                    <Card
                        size="small"
                        title={<><CheckCircleOutlined style={{ color: 'green', marginRight: 8 }} />{successTitle} ({successList.length})</>}
                        bordered={false}
                        bodyStyle={{ padding: 0 }}
                    >
                        <List
                            size="small"
                            bordered
                            dataSource={successList}
                            renderItem={item => <List.Item><Text>{item}</Text></List.Item>}
                            style={{ maxHeight: 300, overflowY: 'auto' }}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card
                        size="small"
                        title={<><CloseCircleOutlined style={{ color: 'red', marginRight: 8 }} />{errorTitle} ({errorList.length})</>}
                        bordered={false}
                        bodyStyle={{ padding: 0 }}
                    >
                        <List
                            size="small"
                            bordered
                            dataSource={errorList}
                            renderItem={item => <List.Item><Text>{item}</Text></List.Item>}
                            style={{maxHeight: 300, overflowY: 'auto' }}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
